module.exports = __webpack_public_path__ + "static/media/medida-cubierta.5a813799.png";